var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCameraAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L16.56 0 16.56 15.12 0 15.12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#717F97",
    d: "M7.056 9.36c0 1.274 1.03 2.304 2.304 2.304 1.274 0 2.304-1.03 2.304-2.304 0-1.274-1.03-2.304-2.304-2.304-1.275 0-2.304 1.03-2.304 2.304zm2.304 3.6c1.987 0 3.6-1.613 3.6-3.6s-1.613-3.6-3.6-3.6-3.6 1.613-3.6 3.6 1.613 3.6 3.6 3.6zM4.32 6.48V4.32h2.16V2.16h5.04l1.317 1.44h2.283c.792 0 1.44.648 1.44 1.44v8.64c0 .792-.648 1.44-1.44 1.44H3.6c-.792 0-1.44-.648-1.44-1.44v-7.2h2.16zM2.16 2.16V0H3.6v2.16h2.16V3.6H3.6v2.16H2.16V3.6H0V2.16h2.16z",
    mask: "url(#prefix__b)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera_add.4ad52a23.svg";
export { ForwardRef as ReactComponent };